import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  Button,
  Icon,
  ScrollArea,
} from "@elaniintc/goes-design-system";
import type { VariableType } from "../types";
import { Operations, type Operation } from "../utils/operations";

export const OperationOptions = ({
  group = "right",
  selectedOperation,
  selectedVariableType,
  selectedVariableMetaType,
  onOperationChange,
}: {
  group?: "left" | "right" | "up-right" | "down";
  selectedOperation?: Operation;
  selectedVariableType?: VariableType;
  selectedVariableMetaType?: string;
  onOperationChange: (val: Operation) => void;
}) => {
  const availableOperations = selectedVariableType
    ? Operations[selectedVariableType].filter((op) => {
        if (op.name === "datetime_to_words" && selectedVariableMetaType !== "datetime") {
          return false;
        }
        return true;
      })
    : [];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          className="h-full"
          group={group}
          variant="quiet"
          disabled={!selectedVariableType}
        >
          {selectedVariableType && selectedOperation
            ? Operations[selectedVariableType].find(
                (op) => op.name === selectedOperation.name,
              )?.label
            : "Operación"}
          <Icon name="angle-down" type="far" />
        </Button>
      </DropdownMenuTrigger>
      {selectedVariableType && (
        <DropdownMenuContent
          side="bottom"
          className="border-neutral h-full rounded-lg w-70"
        >
          <ScrollArea className="h-66">
            {availableOperations.map((option) => (
              <DropdownMenuItem
                key={`${option.name}-${option.label}`}
                onClick={() => onOperationChange(option)}
              >
                <div className="flex flex-col">
                  <span className="text-body font-semibold">
                    {option.label}
                  </span>
                  <span className="text-body-quiet font-mono">
                    {option.description}
                  </span>
                </div>
              </DropdownMenuItem>
            ))}
          </ScrollArea>
        </DropdownMenuContent>
      )}
    </DropdownMenu>
  );
};

export const DateGetOperations = ({
  selectedDateGetFormat,
  dateGetFormatOptions,
  onDateGetFormatChange,
}: {
  selectedDateGetFormat?: string;
  dateGetFormatOptions: Array<{
    value: string;
    label: string;
    description: string;
  }>;
  onDateGetFormatChange: (value: string) => void;
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <Button className="h-full" variant="quiet" group="right">
          {selectedDateGetFormat
            ? dateGetFormatOptions.find(
                (f) => f.value === selectedDateGetFormat,
              )?.description
            : "Formato"}
          <Icon name="angle-down" type="far" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        side="bottom"
        className="border-neutral h-full rounded-lg w-70"
      >
        <ScrollArea className="h-66">
          {dateGetFormatOptions.map((option) => (
            <DropdownMenuItem
              key={option.value}
              onClick={() => onDateGetFormatChange(option.value)}
            >
              <div className="flex flex-col">
                <span className="text-body font-semibold">{option.label}</span>
                <span className="text-body-quiet font-mono">
                  {option.description}
                </span>
              </div>
            </DropdownMenuItem>
          ))}
        </ScrollArea>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export const DateStringOperations = ({
  selectedDateToStringFormat,
  dateToStringFormatOptions,
  onDateToStringFormatChange,
}: {
  selectedDateToStringFormat?: string;
  dateToStringFormatOptions: Array<{
    value: string;
    label: string;
    description: string;
  }>;
  onDateToStringFormatChange: (value: string) => void;
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          className="h-full w-full justify-between"
          variant="quiet"
          group="down"
        >
          {selectedDateToStringFormat
            ? dateToStringFormatOptions.find(
                (f) => f.value === selectedDateToStringFormat,
              )?.description
            : "Formato"}
          <Icon name="angle-down" type="far" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        side="bottom"
        className="border-neutral h-full rounded-lg w-70"
      >
        <ScrollArea className="h-66">
          {dateToStringFormatOptions.map((option) => (
            <DropdownMenuItem
              key={option.value}
              onClick={() => onDateToStringFormatChange(option.value)}
            >
              <div className="flex flex-col">
                <span className="text-body font-semibold">{option.label}</span>
                <span className="text-body-quiet font-mono">
                  {option.description}
                </span>
              </div>
            </DropdownMenuItem>
          ))}
        </ScrollArea>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
